namespace Gamification.Gamification {
    export interface UtentiProdottiAlertRow {
        UserId?: number;
        TenantId?: number;
        IdUtenteProdottoAlert?: number;
        IdUtenteProdotto?: number;
        IdRaccomandazione?: number;
        Nome?: string;
        Messaggio?: string;
        DataOra?: string;
        IdRaccomandazioneNome?: string;
        IdRaccomandazioneMessaggio?: string;
        IdRaccomandazioneCondizione?: string;
        IdRaccomandazioneCondizioneVerificata?: string;
        IdRaccomandazioneBonus?: string;
    }

    export namespace UtentiProdottiAlertRow {
        export const idProperty = 'IdUtenteProdottoAlert';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.UtentiProdottiAlert';
        export const lookupKey = 'Gamification.UtentiProdottiAlert';

        export function getLookup(): Q.Lookup<UtentiProdottiAlertRow> {
            return Q.getLookup<UtentiProdottiAlertRow>('Gamification.UtentiProdottiAlert');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdUtenteProdottoAlert = "IdUtenteProdottoAlert",
            IdUtenteProdotto = "IdUtenteProdotto",
            IdRaccomandazione = "IdRaccomandazione",
            Nome = "Nome",
            Messaggio = "Messaggio",
            DataOra = "DataOra",
            IdRaccomandazioneNome = "IdRaccomandazioneNome",
            IdRaccomandazioneMessaggio = "IdRaccomandazioneMessaggio",
            IdRaccomandazioneCondizione = "IdRaccomandazioneCondizione",
            IdRaccomandazioneCondizioneVerificata = "IdRaccomandazioneCondizioneVerificata",
            IdRaccomandazioneBonus = "IdRaccomandazioneBonus"
        }
    }
}
